<template>
    <div
        v-if="items && items.length"
        class="banner-list"
    >
        <BaseBanner
            v-for="(item, index) in items"
            :key="index"
            :url="`/${item.uri}`"
            :image="item.logo ? item.logo[0] : null"
            :class="{'base-banner--secondary' : secondaryStyle}"
        >
            {{ item.title }}
        </BaseBanner>
    </div>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    secondaryStyle: {
        type: Boolean,
        required: false,
        default: false
    }
});
</script>

<style lang="less">
.banner-list {
    .card-grid();
}

.banner-list--extra-spacing {
    margin-top: var(--spacing-lg);
}
</style>
